import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitfullName',
})
export class SplitFullNamePipe implements PipeTransform {
  transform(value: string, args?: any): any {
    if (!value) {
      return '';
    }
    const splitFullName = value.split(' ');
    return splitFullName[0] + ' ' + splitFullName[1][0] + '.';
  }
}
